"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'webhook.cronIntervals.every_5_minutes': '每5分钟',
    'webhook.cronIntervals.every_10_minutes': '每10分钟',
    'webhook.cronIntervals.every_15_minutes': '每15分钟',
    'webhook.cronIntervals.every_30_minutes': '每30分钟',
    'webhook.cronIntervals.every_45_minutes': '每45分钟',
    'webhook.cronIntervals.every_hour': '每小时',
    'webhook.cronIntervals.every_2_hours': '每2小时',
    'webhook.cronIntervals.every_6_hours': '每6小时',
    'webhook.cronIntervals.every_12_hours': '每12小时',
    'webhook.cronIntervals.daily': '每天（午夜）',
    'webhook.cronIntervals.weekly': '每周（周日午夜）',
};
